import { render } from "./CookiesTabs.vue?vue&type=template&id=73aaf281&scoped=true"
import script from "./CookiesTabs.vue?vue&type=script&lang=js"
export * from "./CookiesTabs.vue?vue&type=script&lang=js"

import "./CookiesTabs.vue?vue&type=style&index=0&id=73aaf281&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73aaf281"]])

export default __exports__